import React from 'react';
import styled from 'styled-components';

interface MaybeLinkProps {
  children: React.ReactNode;
  ctaUrl?: string;
  onClick?: () => void;
  ariaLabel?: string;
  openIn?: string;
}

export const MaybeLink: React.FC<MaybeLinkProps> = ({
  children,
  ctaUrl,
  onClick,
  ariaLabel,
  openIn = 'Same tab',
}: MaybeLinkProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  // Helper function to handle relative URLs
  const setCtaUrl = (link?: string) => {
    console.log('🚀 ~ setCtaUrl ~ link:', link);
    if (!link) return undefined;
    if (!(link.indexOf('/') === 0)) {
      return link;
    }
    const url = typeof window !== 'undefined' && window.location.origin;
    return typeof window !== 'undefined' ? (url as string) + link : undefined;
  };

  return ctaUrl ? (
    <StyledLink
      data-testid="ImageLink"
      href={setCtaUrl(ctaUrl)}
      target={openIn === 'Same tab' ? '_self' : '_blank'}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {children}
    </StyledLink>
  ) : (
    <>{children}</>
  );
};

const StyledLink = styled.a`
  display: block;
  cursor: pointer;
`;
